export default __webpack_public_path__ + "static/media/7.fbf378a7.jpg";